export default __webpack_public_path__ + "static/media/butterfly.6498de5a.jpg";